import React from 'react';
import { Input, InputNumber } from 'antd';
import { Field, ToggleField } from '../Form';

/** the fields core_mixins.RequestMixin puts on every outbound integration */
export const HTTP_REQUEST_FIELDS = ['target_url', 'authorization', 'verify', 'timeout'];

/**
 * Target URL, credentials and transport options — identical for webhooks and
 * healthchecks because both are a RequestMixin on the API.
 *
 * Fields, not a section: both forms are one sheet with a single grid, so these
 * take their places in it beside the entity's own rather than opening a card.
 *
 * The defaults give the URL a row of its own — it is the longest thing on
 * either form and the only one that suffers from being narrow — and put the
 * three short controls on the next row, which they fill exactly. A caller with
 * something to seat beside the URL narrows it and keeps the row full.
 */
const HttpRequestFields = ({
    urlSpan = 12,
    authSpan = 6,
    timeoutSpan = 3,
    verifySpan = 3,
}: {
    urlSpan?: number;
    authSpan?: number;
    timeoutSpan?: number;
    verifySpan?: number;
}) => (
    <>
        <Field
            name="target_url"
            label="Target URL"
            span={urlSpan}
            rules={[
                { required: true, message: 'Enter the URL NetOrca should call' },
                { type: 'url', message: 'Enter a full URL, including https://' },
            ]}
        >
            <Input className="nf-mono" placeholder="https://example.com/netorca" inputMode="url" />
        </Field>

        <Field
            name="authorization"
            label="Authorization header"
            span={authSpan}
            hint={
                <>
                    Example: <code>Bearer &lt;token&gt;</code>, <code>Token &lt;token&gt;</code> or{' '}
                    <code>Api-Key &lt;key&gt;</code>.
                </>
            }
            rules={[{ max: 300, message: 'Keep the header under 300 characters' }]}
        >
            <Input.Password className="nf-mono" placeholder="Bearer …" autoComplete="off" />
        </Field>

        <Field
            name="timeout"
            label="Timeout"
            span={timeoutSpan}
            rules={[{ required: true, message: 'Set a timeout between 1 and 60 seconds' }]}
        >
            {/* the API caps this at 60 (MaxValueValidator on RequestMixin.timeout) */}
            <InputNumber min={1} max={60} suffix="sec" style={{ width: '100%' }} />
        </Field>

        <ToggleField name="verify" span={verifySpan} label="Verify TLS certificate" />
    </>
);

export default HttpRequestFields;
